/*
  reports state
*/
export default {
  list: [],
  dictList: {}
}
